import $ from 'jquery'
import { Alert } from '../functions'

const object = vnObject


$('.js-change-formula').on( 'click', function () {
    const formData = new FormData()
    formData.append('action', 'vn_change_plan')
    formData.append('price_id', $(this).data('price-id') )
    formData.append('sub_id', $(this).data('sub-id') )
    formData.append('place_id', $(this).data('place-id') )
    formData.append('is_premium', $(this).data('premium') )
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
            Alert('warning', object.formWait, false)
        },
        processData: false,
        contentType: false,
        success: (res) => {
            Alert(res.success, res.data.message)
            if (res.success && res.data.redirect) {
                window.location = res.data.redirect;
            } else {
                location.reload();
            }
        },
    })
})